import { ActionType } from '../../types/actionType';
import { Action } from './actions';

type State = {
	loading?: number;
};

const initialState: State = {
	loading: undefined,
};

const reducer = (state: State = initialState, action: Action): State => {
	switch (action.type) {
		case ActionType.MULTIMEDIA_REQUEST_LOADING:
			return { ...state, loading: action.payload };
		case ActionType.CLEAN_REDUCER:
		case ActionType.LOG_OUT:
			return initialState;
		default:
			return state;
	}
};

export default reducer;
